<template>
  <div class="not-found-page">
    <div class="centered">
      <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
      <p>The page you requested could not be found.</p>
      <router-link to="/" >Go Home</router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss">
.not-found-page {
  .full-page > .content,
  .centered {
    // min-height: calc(100vh - 260px);
    margin-top: 10%;
  }
  .not-found-icon {
    margin-right: 10px;
  }
  .centered {
    h1,
    i {
      font-size: 50px;
    }
    p, a {
      font-size: 20px;
      color: white;
    }
    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white!important;
  }
}
</style>
